// @ts-nocheck
import Container from "@/components/Container/Container";
import { css } from "@emotion/react";
import { mq } from "@/constants/breakpoints";
import NewPricingCard from "./NewPricingCard";
import NewPricingToggle from "./NewPricingToggle";
import React from "react";

// eslint-disable-next-line no-unused-vars
interface PlanSectionProps {
  isAnnual: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsAnnual: (_isAnnual: boolean) => void;
  pricingPlans?: Array<{
    name: string;
    monthlyPrice: number;
    annualPrice: number;
    annualPricePerMonth: number;
    buttonLabel: string;
    buttonRelativeLink: string;
    monthlyAvailable?: boolean;
    specialOffer?: {
      textBeforeAmount?: string;
      amountText: string;
      textAfterAmount?: string;
      amountColor?: string;
    };
  }>;
}

const PlanSection = ({
  isAnnual,
  setIsAnnual,
  pricingPlans,
}: PlanSectionProps) => {
  const handleToggle = (newValue: boolean) => {
    setIsAnnual(newValue);
  };

  // Ensure we have exactly 3 pricing plans
  const plans = pricingPlans?.slice(0, 3) || [];

  return (
    <Container
      css={css`
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        padding: 0px !important;
        margin-left: 0;
        margin-right: 0;
        ${mq["lg"]} {
          padding-left: 0px;
          padding-right: 0px;
          flex-direction: row;
          gap: 0;
          align-items: flex-start;
          justify-content: center;
        }
      `}
    >
      {/* Toggle section */}
      <div
        css={css`
          width: 100%;
          margin-bottom: 16px;
          ${mq["lg"]} {
            width: 280px;
            min-width: 280px;
            max-width: 280px;
            margin-bottom: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          }
        `}
      >
        <NewPricingToggle isAnnual={isAnnual} onClick={handleToggle} />
      </div>
      {/* Plans section */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 1200px;
          border: 2px solid #daf2ff;
          border-radius: 24px;
          background: #fff;
          overflow: hidden;
          ${mq["lg"]} {
            flex-direction: row;
            flex: 1;
            gap: 0;
            width: auto;
            max-width: none;
            align-items: stretch;
          }
        `}
      >
        {plans.map((plan, index) => (
          <React.Fragment key={plan.name}>
            <NewPricingCard
              pricingPlan={plan}
              isAnnual={isAnnual}
              disabled={!isAnnual && !plan.monthlyAvailable}
              position={
                index === 0
                  ? "first"
                  : index === plans.length - 1
                  ? "last"
                  : "middle"
              }
            />
            {index < plans.length - 1 && (
              <div
                css={css`
                  height: 2px;
                  background: #daf2ff;
                  width: 100%;
                  border: solid 1px #daf2ff;
                  box-sizing: border-box;
                  ${mq["lg"]} {
                    width: 2px;
                    height: auto;
                    box-sizing: border-box;
                  }
                `}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </Container>
  );
};

export default PlanSection;
